module.exports = __webpack_public_path__ + "static/img/no_wishes.683eb380.png";